const { createSelector } = require('reselect');
const userUtils = require('utils/User');
const { userSelector } = require('selectors/user/userSelector');

const firstNameSelector = createSelector(userSelector, () => userUtils.getProfileFirstName());

module.exports = { firstNameSelector };
